import { Gender } from "../../../../../../../server/models/shared";
import { ActivityWithBrand } from "../../../../../../../server/models/activity";

export const brandUserToConditionProps: (activity: ActivityWithBrand) => { label: string; value: string }[] = (
	activity,
) => {
	return [
		{ label: "性別", value: Gender[activity.category.gender] },
		{ label: "年齢", value: "15～69歳" },
		{ label: "ブランド", value: activity.brand.name },
	];
};
